import { ApiRoutes, AppPaginationOptions, QueryError, WithPagination } from '@/common/interfaces';
import { apiExecutor, buildMutation, buildQuery } from '@/common/services';

import { Hosting, HostingsFormFields, HostingsQueryKeys } from '@/modules/Hostings';

export const useGetAllHostingsQuery = (paginationOptions: AppPaginationOptions, search?: string) =>
  buildQuery<WithPagination<Hosting>, QueryError>([HostingsQueryKeys.GetAll, { ...paginationOptions, search }], async () => {
    const { data } = await apiExecutor.get<WithPagination<Hosting>>(ApiRoutes.Hostings, {
      params: { ...paginationOptions, search }
    });
    return data;
  });

export const useGetByIdHostingsQuery = (id: string) =>
  buildQuery<Hosting, QueryError>([HostingsQueryKeys.GetOneById, id], async () => {
    const { data } = await apiExecutor.get<Hosting>(ApiRoutes.HostingsById.replace(':hostingId', id));
    return data;
  });

export const useCreateHostingsMutation = () =>
  buildMutation<Hosting, QueryError, HostingsFormFields>([HostingsQueryKeys.Create], async (postData) => {
    const { data } = await apiExecutor.post<Hosting>(ApiRoutes.Hostings, {
      ...postData
    });
    return data;
  });

export const useDeleteHostingsMutation = (hostingId: string) =>
  buildMutation<void, QueryError, void>([HostingsQueryKeys.Delete, hostingId], async () => {
    await apiExecutor.delete<void>(ApiRoutes.HostingsById.replace(':hostingId', hostingId));
  });

export const useAutocompleteHostingsQuery = (params: { query: string; includedIds?: string[]; }) =>
  buildQuery<Pick<Hosting, 'id' | 'name'>[], QueryError>([HostingsQueryKeys.Autocomplete, params], async () => {
    const { data } = await apiExecutor.get<Pick<Hosting, 'id' | 'name'>[]>(ApiRoutes.HostingsAutocomplete, {
      params: { q: params.query, includedIds: params?.includedIds?.length ? String(params.includedIds) : undefined, }
    });
    return data;
  });

export const useBreadcrumbHostingsQuery = (id: string) =>
  buildQuery<string, QueryError>([HostingsQueryKeys.Breadcrumb], async () => {
    const { data } = await apiExecutor.get<string>(ApiRoutes.HostingsBreadcrumb.replace(':hostingId', id));
    return data;
  });
